
import { Component, Vue, Prop, VModel } from "vue-property-decorator";
import PazLoader from "@pazion/pazion-core/src/components/utils/PazLoader.vue";
import { updateCard } from "@pazion/pazion-catalog/src/services/cards-service";
import PazToast from "@pazion/pazion-core/src/components/utils/PazToast.vue";
import type { ICardModel } from "@pazion/pazion-catalog/src/models/member_card.model";
import { VueEditor, Quill } from "vue2-editor";
import htmlEditButton from "quill-html-edit-button";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";

Quill.register('modules/htmlEditButton', htmlEditButton)

@Component({
  components: {
    PazLoader,
    PazToast,
    PazTooltipButton,
    VueEditor
  },
})
export default class CardDetailsAttributes extends Vue {

  refs!: {
    toast: PazToast;
    emailEditor: any
  }

  @VModel({
    default: false,
  })
  showAttrModal!: boolean;

  @Prop() selectedCard!: ICardModel;

  public loading: boolean = false;
  public htmTemplate: string = ''

  public customToolbar = [
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }, { 'align': [] }]
  ];

  public editorSettings = {
    modules: {
      htmlEditButton: {
        msg: "Edit the content in HTML format", 
        okText: "Ok", 
        cancelText: "Cancel", 
        buttonHTML: "&#10096; &#10097", 
        buttonTitle: "Show HTML source", 
        syntax: false, 
        prependSelector: 'div#htmlEditor',
      }
      }
  }

  async saveAttrValue() {
    this.loading = true;
    const res = await updateCard(this.selectedCard.id, { htmlEmail: this.htmTemplate });
    this.loading = false;
    if (res) {
      this.$emit('onCardUpdate');
      this.$emit('onClose');
    }
  }

  setVar(field: string) {
    let mergeFieldText = `{${field}}`;
    var selection = this.$refs.emailEditor.quill.getSelection(true);
    this.$refs.emailEditor.quill.insertText(selection.index, mergeFieldText);
  }

  mounted() {
    // NOTE: Convert html to Quill
    if (this.$refs.emailEditor?.quill) {
      const converted = this.$refs.emailEditor.quill.clipboard.convert(this.selectedCard.htmlEmail)
      this.$refs.emailEditor.quill.setContents(converted)
    }
  }

} //
